module.exports = __webpack_public_path__ + "media/images/email/facebook-f-c0a2cdbf462aa86302d11757da113800.png";